import Lenis from "lenis";

let lenisInstance: Lenis | null = null;

export const setLenisInstance = (instance: Lenis | null) => {
  lenisInstance = instance;
};

export const scrollToId = (id: string) => {
  const target = document.querySelector(id) as HTMLElement | null;
  if (!target) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -84, duration: 1.3 });
  } else {
    const y = target.getBoundingClientRect().top + window.scrollY - 84;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
